<template>
  <div class="techo">
    <div class="top">
      <img class="line" src="../assets/index/line.png" alt="" />
      <div class="title">技术成就</div>
    </div>
    <div class="btmWrap">
      <div class="btm">
        <div class="desc">
          阁韵始终坚守“精工筑阁 · 匠心谱韵“的精神
          <br />精雕细琢每扇门窗，用工匠精神完善每个细节
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
          "
          class="imgWrap"
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <img class="zxImg1" src="../assets/about/zx1.png" alt="" />
            <div class="zxDesc">2019年阁韵木窗被国家评为“高新技术企业”称号</div>
          </div>
          <div v-if="this.$isMobile"></div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              border: 1px solid #f5f5f5;
            "
          >
            <img class="zxImg" src="../assets/about/zx2.png" alt="" />
            <div class="zxDesc">2019年阁韵木窗荣获“康居产品认证证书”</div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <img class="zxImg2" src="../assets/about/zx3.png" alt="" />
            <div class="zxDesc">康居产品认证证书</div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <img class="zxImg2" src="../assets/about/zx4.png" alt="" />
            <div class="zxDesc">环境管理体系认证证书</div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <img class="zxImg2" src="../assets/about/zx5.png" alt="" />
            <div class="zxDesc">德国被动房研究所PHI认证证书</div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <img class="zxImg2" src="../assets/about/zx6.png" alt="" />
            <div class="zxDesc">职业健康安全管理体系认证证书</div>
          </div>
        </div>
        <div class="desc">时至今日，阁韵木窗已申请专利40余项，发明专利5项</div>
        <div style="margin-top: 24px">
          <img class="zs6" src="../assets/about/zs6.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Technology",

  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.techo {
  .top {
    text-align: left;
    margin-left: 320px;
    background: #ffffff;
    padding: 59px 0;
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 24px;
    }
  }
  .btmWrap {
    background: #f2f2f2;
    .btm {
      width: 1280px;
      margin: 0 auto;
      .desc {
        padding: 44px 0px;
        font-size: 32px;
        font-family: MicrosoftYaHei;
        font-weight: 500;
        color: #004c31;
        line-height: 42px;
        text-align: left;
        border-bottom: 1px dotted #d2d2d2;
      }
      .zs6 {
        width: 1280px;
        padding-bottom: 100px;
      }
      .zxImg1 {
        margin-top: 44px;
        width: 837px;
        height: 545px;
      }
      .zxImg2 {
        margin-top: 44px;
        width: 301px;
        height: auto;
      }
      .zxImg:hover,
      .zxImg1:hover,
      .zxImg2:hover {
        transform: scale(1.2); // 放大1.5倍
        transition: all 0.3s; // 设置加载时间
      }
      .zxImg {
        margin-top: 44px;
        width: 383px;
        height: 545px;
      }
      .zxDesc {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #6c7a77;
        text-align: left;
        line-height: 36px;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .techo {
    .top {
      text-align: left;
      margin-left: 320px;
      background: #ffffff;
      width: auto;
      padding: 59px 0;
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 24 * 2px;
      }
    }
    .btmWrap {
      background: #f2f2f2;
      .btm {
        width: 1280px;
        margin: 0 auto;
        .desc {
          padding: 44px 0px;
          font-size: 32 * 2px;
          font-family: MicrosoftYaHei;
          font-weight: 500;
          color: #004c31;
          line-height: unset;
          text-align: left;
          border-bottom: 1px dotted #d2d2d2;
        }
        .imgWrap {
          display: flex;
          align-items: center;
          justify-content: center !important;
          div {
            align-items: center !important;
            justify-content: center !important;
          }
        }
        .zs6 {
          width: 1280px;
          padding-bottom: 100px;
        }
        .zxImg1 {
          margin-top: 44px;
          width: 67.594vw !important;
          height: auto;
        }
        .zxImg2 {
          margin-top: 44px;
          width: 67.594vw;
          height: auto;
        }
        .zxImg:hover,
        .zxImg1:hover,
        .zxImg2:hover {
          transform: scale(1); // 放大1.5倍
          transition: all 0.3s; // 设置加载时间
        }
        .zxImg {
          margin-top: 44px;
          width: 67.594vw;
          height: auto;
        }
        .zxDesc {
          margin-top: 48px;
          font-size: 20 * 2px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #6c7a77;
          text-align: left;
          line-height: 36px;
        }
      }
    }
  }
}
</style>
